/**
 * Product Pack Premium - Gestion des packs avec quantité uniquement
 */

class ProductPackPremium extends HTMLElement {
  constructor() {
    super();
    this.selectedPack = 0;
    this.productId = null;
    this.initialized = false;
  }

  connectedCallback() {
    if (this.initialized) return;
    
    this.productId = this.dataset.productId;
    
    // Attendre que le DOM soit complètement prêt
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.init());
    } else {
      // Utiliser requestAnimationFrame pour s'assurer que le DOM est rendu
      requestAnimationFrame(() => {
        setTimeout(() => this.init(), 50);
      });
    }
    
    this.initialized = true;
  }

  init() {
    this.attachEventListeners();
    this.updateButton();
  }

  attachEventListeners() {
    // Sélection des cartes
    const cards = this.querySelectorAll('component-pack-premium');
    
    if (cards.length === 0) {
      console.warn('Aucune carte pack trouvée');
      return;
    }

    cards.forEach((card, index) => {
      // Utiliser once: false pour permettre plusieurs clics
      const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.selectPack(index);
      };
      
      // Retirer les anciens listeners s'ils existent
      card.removeEventListener('click', handleClick);
      card.removeEventListener('mousedown', handleClick);
      
      // Ajouter les nouveaux listeners
      card.addEventListener('click', handleClick, { passive: false });
      card.addEventListener('mousedown', handleClick, { passive: false });
    });

    // Soumission du formulaire
    const form = this.querySelector('#product-pack-premium-form');
    if (form) {
      const handleSubmit = (e) => {
        e.preventDefault();
        this.addToCart();
      };
      
      form.removeEventListener('submit', handleSubmit);
      form.addEventListener('submit', handleSubmit);
    }
  }

  selectPack(index) {
    const cards = this.querySelectorAll('component-pack-premium');
    
    if (cards.length === 0) {
      return;
    }

    cards.forEach((card, i) => {
      if (i === index) {
        card.classList.add('pack-premium__card--selected');
        this.selectedPack = index;
      } else {
        card.classList.remove('pack-premium__card--selected');
      }
    });
    
    this.updateButton();
  }

  updateButton() {
    const button = this.querySelector('#product-pack-premium-submit');
    const selectedCard = this.querySelector(`component-pack-premium[data-pack-index="${this.selectedPack}"]`);
    
    if (!selectedCard || !button) {
      return;
    }

    const quantity = parseInt(selectedCard.dataset.quantity);
    
    if (quantity > 0 && this.productId) {
      button.disabled = false;
      button.classList.remove('disabled');
    } else {
      button.disabled = true;
      button.classList.add('disabled');
    }
  }

  async addToCart() {
    const button = this.querySelector('#product-pack-premium-submit');
    const selectedCard = this.querySelector(`component-pack-premium[data-pack-index="${this.selectedPack}"]`);
    
    if (!selectedCard || !button || !this.productId) {
      return;
    }

    const quantity = parseInt(selectedCard.dataset.quantity);

    if (quantity <= 0) {
      alert('Quantité invalide');
      return;
    }

    // Désactiver le bouton et afficher le spinner
    button.disabled = true;
    const spinner = button.querySelector('.loading-overlay__spinner');
    if (spinner) spinner.classList.remove('hidden');

    try {
      // Ajouter le produit X fois au panier
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: this.productId,
          quantity: quantity
        })
      });

      if (!response.ok) {
        throw new Error('Erreur lors de l\'ajout au panier');
      }

      const data = await response.json();

      // Rediriger vers la page panier (plus d'ouverture du drawer)
      window.location.href = window.routes?.cart_url || '/cart';
    } catch (error) {
      console.error('Erreur lors de l\'ajout au panier:', error);
      alert('Une erreur est survenue. Veuillez réessayer.');
    } finally {
      button.disabled = false;
      if (spinner) spinner.classList.add('hidden');
    }
  }
}

// S'assurer que le custom element est défini avant de l'utiliser
if (!customElements.get('product-pack-premium')) {
  customElements.define('product-pack-premium', ProductPackPremium);
}

if (!customElements.get('component-pack-premium')) {
  customElements.define('component-pack-premium', class extends HTMLElement {});
}
